enum CourseURL {
  EliteSport = "https://akomaps.com/app/course/61a681c235c6e8537c8e9918/summary",
  FormulaWomenIntroduction = "https://akomaps.com/app/course/61f97fb2e3b76c0abedaf233/summary",
}

export const TheCourseURL = CourseURL.FormulaWomenIntroduction;